const examplecurl =
  'curl -d "param1=value1&param2=value2" -H "Content-Type: application/x-www-form-urlencoded" -X POST https://example.com/example-api';
export default examplecurl;
